import SocialProfileConfirmation, {
  SocialProfileConfirmationStateProps,
} from 'components/features/socialFeed/SocialProfileConfirmation/SocialProfileConfirmation'
import { connectOptionally, OptionalRendererProps, NO_RENDER, createPositiveRendererProps } from 'tangle-shared'
import { State } from 'interfaces/state'
import { yourPeergroupSelector } from 'selectors/peergroupSelectors'

const mapStateToProps = (state: State): OptionalRendererProps<SocialProfileConfirmationStateProps> => {
  const yourPeergroup = yourPeergroupSelector(state)
  if (!yourPeergroup) {
    return NO_RENDER()
  }

  return createPositiveRendererProps({
    peergroup: yourPeergroup,
  })
}

const SocialProfileConfirmationContainer = connectOptionally<
  SocialProfileConfirmationStateProps, {}
>(mapStateToProps, () => ({}))(SocialProfileConfirmation)

export default SocialProfileConfirmationContainer
